export default __webpack_public_path__ + "static/media/reel.115b4392.mp4";